import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['María L.', 'Juan P.', 'Sofía M.', 'Lucas R.', 'Valentina G.', 'Martín S.', 'Lucía B.', 'Diego F.', 'Camila T.', 'Nicolás A.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bariloche'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setVisible(false);
        // Schedule next notification
        setTimeout(showNotification, Math.random() * 15000 + 10000); // Random delay between 10-25s
      }, 4000);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-1">
      <div className="bg-white rounded-lg shadow-lg border-l-4 border-[#4a7c2c] p-4 max-w-xs flex items-start gap-3 relative" data-id="element-2">
        <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" data-id="element-3">
          <X className="w-3 h-3" data-id="element-4" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-5">
          <CheckCircle2 className="w-5 h-5 text-[#4a7c2c]" data-id="element-6" />
        </div>

        <div data-id="element-7">
          <p className="text-xs text-gray-500 font-medium uppercase tracking-wide" data-id="element-8">
            Nueva compra
          </p>
          <p className="text-sm text-gray-800 font-medium" data-id="element-9">
            <span className="font-bold" data-id="element-10">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-600 mt-0.5" data-id="element-11">
            Compró "Guía Definitiva de Gírgolas"
          </p>
        </div>
      </div>
    </div>;
}